<body>
    
<div class="row">
    <div class="col-md-12 ">
        <app-header></app-header>
    </div>
</div>
<div class="row mt-4">
    <div class="col-md-3 show-menu box-shadow">
        <app-sidebar ></app-sidebar>
        
    </div>
    <div class="col-md-9">
        <router-outlet></router-outlet>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-12">
        <app-footer></app-footer>
    </div>
</div>

</body>